import { useQuery } from "@tanstack/react-query"
import { getPatientIssuers } from "../api/statistics"

const useFetchPatientIssuers = () =>
  useQuery({
    queryKey: ["patient-issuers"],
    queryFn: () => getPatientIssuers(),
    select: (data) => data?.data || [],
    retry: false,
  })

export default useFetchPatientIssuers
